const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoNacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#005f86"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,4c-2.76,0-5,2.24-5,5s2.24,5,5,5,5-2.24,5-5-2.24-5-5-5ZM11.82,11.9s0,.01-.01.01h-5.6s-.01,0-.01-.01v-.56s0-.01.01-.01h5.6s.01,0,.01.01v.56h0ZM8.04,10.43v-2.84h.64v2.84h.63v-2.84h.64v2.84h.64v-2.84h.64v2.84h.29v.58s0,.01-.01.01h-5.02s-.01,0-.01-.01v-.58h.28v-2.84h.64v2.84h.64,0ZM12.01,6.99l-.18.31s-.02.02-.03.02h-5.59s-.02,0-.03-.02l-.18-.31s0-.02,0-.03l2.98-1.58s.03,0,.04,0l2.98,1.58s.01.02,0,.03h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.44,6.78l-1.4-.68s-.02-.01-.03-.01c0,0-.02,0-.03,0l-1.42.69s0,0,0,0h2.88s.01,0,0,0Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoNacion);
export default __webpack_public_path__ + "static/media/banco-nacion.b093f493709f4cd8495bcb3783242756.svg";
export { ForwardRef as ReactComponent };